"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = void 0;
var _styledComponents = require("styled-components");
var _normalize = require("./normalize");
var _fonts = require("./fonts");
const GlobalStyles = exports.GlobalStyles = (0, _styledComponents.createGlobalStyle)(["", " ", " html{font-size:62.5%;margin:0;padding:0;height:100%;}body{position:absolute;width:100%;height:100%;padding:0;margin:0;font-family:", ";font-size:1.6rem;-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto;-webkit-touch-callout:none;*{-webkit-tap-highlight-color:", ";}}a,abbr,address,article,aside,audio,b,blockquote,body,caption,cite,code,dd,del,dfn,dialog,div,dl,dt,em,fieldset,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,hr,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,p,pre,q,samp,section,small,span,strong,sub,sup,table,tbody,td,tfoot,th,thead,time,tr,ul,var,video{padding:0;margin:0;border:0;outline:0;}*,*:before,*:after{box-sizing:border-box;padding:0;margin:0;}h1,h2,h3,h4,h5,h6,label,p,button,abbr,a,span,small{-webkit-font-smoothing:antialiased;}a{text-decoration:none;-webkit-tap-highlight-color:", ";}textarea,input{-webkit-appearance:none;border-radius:0;}input:not([type=\"checkbox\"]):not([type=\"radio\"]),button{outline:none;-webkit-appearance:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:", ";}input[required]:-moz-ui-invalid{box-shadow:none;}h1{font-family:", ";font-size:calc(", " * 5.6);font-weight:400;line-height:1.35;}h2{font-family:", ";font-size:calc(", " * 4.5);font-weight:400;line-height:calc(", " * 4.8);}h3{font-family:", ";font-size:calc(", " * 3.4);font-weight:400;line-height:calc(", " * 4);}h4{font-family:", ";font-size:calc(", " * 2.4);font-weight:400;line-height:calc(", " * 3.2);-moz-osx-font-smoothing:grayscale;}h5{font-family:", ";font-size:calc(", " * 2);font-weight:500;line-height:1;}h6{font-family:", ";font-size:calc(", " * 1.6);font-weight:400;line-height:calc(", " * 2.4);}p{font-size:calc(", " * 1.4);font-weight:400;line-height:calc(", " * 2.4);letter-spacing:0;}div[disabled],div[disabled] *,p[disabled],p[disabled] *,span[disabled],span[disabled] *,h1[disabled],h1[disabled] *{color:", ";pointer-events:none;}"], ({
  includeFonts
}) => includeFonts && _fonts.fonts, _normalize.normalize, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.colors.common.outlineColor, ({
  theme
}) => theme.colors.common.outlineLinkColor, ({
  theme
}) => theme.colors.common.outlineColor, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.fontSizes.base, ({
  theme
}) => theme.colors.common.disabledColor);